import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAppearanceSettings as GetAppearanceSettingsQuery,
    GetAppearanceSettings_chatSettings as ChatSettings,
} from 'nutshell-graphql-types';

import GET_APPEARANCE_SETTINGS from '../queries/get-appearance-settings.graphql';

export const useGetAppearanceSettings = (): {
    chatSettings: ChatSettings | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetAppearanceSettingsQuery, Record<any, any>>(
        GET_APPEARANCE_SETTINGS
    );

    return {
        chatSettings: data && data.chatSettings,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
